import { render } from "./EditDashboard.vue?vue&type=template&id=4acd9736"
import script from "./EditDashboard.vue?vue&type=script&lang=js"
export * from "./EditDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__